import { reduxRequest } from "../../../../common/utils/reduxRequest";
import { makeFilterString } from "../../utils/Helper";
import {
  AddBrandsSuccess,
  BrandsLoading,
  GetBrandsDetailsSuccess,
  GetBrandsSuccess,
  GetScrollBrandsSuccess,
} from "./Action";

export const getBrandsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "list",
    successFunction: GetBrandsSuccess,
    url: `/admin/brands${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getScrollBrandsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "filter-brands-list",
    successFunction: GetScrollBrandsSuccess,
    url: `/admin/brands${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const createBrandRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "add",
    successFunction: AddBrandsSuccess,
    action: variables?.action,
    url: `/admin/brands`,
    method: "post",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getBrandDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "details",
    successFunction: GetBrandsDetailsSuccess,
    action: variables?.action,
    url: `/admin/brands/${variables?.brand_id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deleteBrandRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "delete brand",
    action: variables?.action,
    url: `/admin/brands/${variables?.id}`,
    method: "delete",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateBrandRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "update brand",
    url: `/admin/brands/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const activateBrandRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "activate brand",
    action: variables?.action,
    url: `/admin/brands/${variables?.id}/activate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deactivateBrandRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BrandsLoading,
    loadingType: "deactivate brand",
    action: variables?.action,
    url: `/admin/brands/${variables?.id}/deactivate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
